import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Order } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class OrderService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getOrder(id): Promise<Order> {
    return new Order(
      await this.core.services.order.getById(id, {
        // todo
        id: null,
      })
    )
  }

  async getOrders(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: Order[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.order.getList(parameters, schema)
  }

  // core types this as Promise<Order>, but it resolves with the mutation's errors (empty on success)
  cancelReservation(order: Order | Partial<Order>): Promise<Array<any>> {
    return this.core.services.order.cancelReservation(order) as unknown as Promise<Array<any>>
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deleteOrder(order: Partial<Order>): Promise<Order> {todo
  //   return this.core.services.order.dele(Order)
  // }
}

// import { inject, Injectable } from '@angular/core'
// import { HttpClient } from '@angular/common/http'
// import { Order } from 'depoto-core/src/entities'
// import { CoreService } from '../core.service'
//
// @Injectable({ providedIn: 'root' }) // todo do i need this
// export class OrderService {
//   private http = inject(HttpClient)
//   core = inject(CoreService)
//
//   public async getOrder(id): Promise<Order> {
//     return new Order(
//       await this.core.services.order.getById(id, {
//         // todo
//         id: null,
//       })
//     )
//   }
//
//   async getOrders(
//     // todo
//     parameters: any = {
//       page: 1,
//       sort: 'id',
//       direction: 'asc',
//     },
//     schema: any = { id: null }
//   ): Promise<{
//     items: Order[]
//     paginator: { current: null; endPage: null; totalCount: null }
//   }> {
//     return await this.core.services.order.getList(parameters, schema)
//   }
//
//   createOrder(order: Partial<Order>, schema: Order | Partial<Order>): Promise<Order> {
//       return this.core.services.order.create(order, schema)
//   }
//
//   updateOrder(
//     order: Order | Partial<Order>,
//     keepReservation = false,
//     dontSendPayments = false,
//     updateProcessStatus?: string,
//     schema: any = null,
//   ): Promise<Order> {
//       return this.core.services.order.update(order, schema)
//   }
//
//   deleteOrder(order: Partial<Order>): Promise<Order> {
//     return this.core.services.order.deleteReservation(order)
//   }
// }
